import {atomWithStorage} from 'jotai/utils';

/** Sunday (0) or Monday (1) — the two week starts the mini calendar supports. */
export type WeekStart = 0 | 1;

/** Default week start from the viewer's locale (Sunday for US/CA/JP, Monday for most others). */
export const getLocaleWeekStart = (): WeekStart => {
  try {
    const locale = new Intl.Locale(navigator.language);
    const weekInfo = (locale as Intl.Locale & {weekInfo?: {firstDay: number}}).weekInfo;
    if (weekInfo?.firstDay === 1) {
      return 1;
    }
    if (weekInfo?.firstDay === 7) {
      return 0;
    }
  } catch {
    // Fall through to language heuristics.
  }
  return /^en-US|^en-CA|^he|^ja|^ko|^pt-BR/i.test(navigator.language) ? 0 : 1;
};

/** Remembers whether the viewer's calendar week starts on Sunday or Monday. */
export const weekStartAtom = atomWithStorage<WeekStart>(
  'dashboard:calendarWeekStart',
  getLocaleWeekStart()
);
